// ----------------- SEASON -----------------
export const TV_SHOW_SEASON_LOADING = 'TV_SHOW_SEASON_LOADING';
export const TV_SHOW_SEASON_SUCCESS = 'TV_SHOW_SEASON_SUCCESS';
export const TV_SHOW_SEASON_ERROR = 'TV_SHOW_SEASON_ERROR';
